import { finish as loginFinish } from './login';

export function request({
    email, password,
    title, firstName, surname, birthDate, country, currency,
    postCode, addressLine1, addressLine2, city, mobilePhone
}) {
    return {
        type: 'USER_SIGNUP_REQUEST',

        email, password,
        title, firstName, surname, birthDate, country, currency,
        postCode, addressLine1, addressLine2, city, mobilePhone
    };
}

export function error(errors) {
    return {
        type: 'USER_SIGNUP_ERROR',
        errors
    };
}

export function finish(data) {
    return (dispatch) => {
        dispatch(loginFinish(data));

        dispatch({
            type: 'USER_SIGNUP_FINISH'
        });
    };
}

export function clear() {
    return {
        type: 'USER_SIGNUP_CLEAR'
    };
}
